import { render, staticRenderFns } from "./RecoverDetail.vue?vue&type=template&id=764f8428&scoped=true"
import script from "./RecoverDetail.vue?vue&type=script&lang=js"
export * from "./RecoverDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f8428",
  null
  
)

export default component.exports